"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var moment_1 = __importDefault(require("moment"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var styles = __importStar(require("./DatePickerNew.module.css"));
var DatePickerNew = (function (_super) {
    __extends(DatePickerNew, _super);
    function DatePickerNew(props) {
        var _this = _super.call(this, props) || this;
        _this.pdf = false;
        _this.handleChangeDate = function (date) {
            var _a = _this.props, id = _a.id, onChange = _a.onChange;
            onChange(id, date);
        };
        _this.pdf = document.body.classList.contains("pdf");
        return _this;
    }
    DatePickerNew.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, _b = _a.errors, errors = _b === void 0 ? {} : _b, page = _a.page, classNameWrap = _a.classNameWrap, className = _a.className, readonly = _a.readonly, minDate = _a.minDate;
        var value = "";
        if (page)
            value = json_data[page][id];
        else
            value = json_data[id];
        var error = errors[id];
        if (json_data[id]) {
            value = moment_1.default(json_data[id]).format("MM/DD/YYYY");
        }
        var convertValue = value;
        if (!convertValue)
            convertValue = undefined;
        var classNameDateWrap = "c-datepicker";
        if (classNameWrap)
            classNameDateWrap += " " + classNameWrap;
        return (React.createElement("div", { className: classNameDateWrap },
            React.createElement(react_datepicker_1.default, { id: id, selected: Date.parse(convertValue), onChange: this.handleChangeDate, className: className, readOnly: readonly, minDate: minDate && new Date(minDate) }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return DatePickerNew;
}(react_1.Component));
exports.DatePickerNew = DatePickerNew;
//# sourceMappingURL=data:application/json;base64,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